import React from 'react'

import PropTypes from 'prop-types'

import IconBase, { Path } from '../IconBase/IconBase'

function Username({
  color = 'icon.primary',
  fill = 'transparent',
  stroke,
  ...props
}) {
  return (
    <IconBase viewBox='0 0 14 12' {...props}>
      <Path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M5.85147 3.64541C6.37868 4.17261 6.37868 5.02739 5.85147 5.55459C5.32426 6.0818 4.46949 6.0818
         3.94228 5.55459C3.41507 5.02739 3.41507 4.17261 3.94228 3.64541C4.46949 3.1182 5.32426 3.1182 5.85147 3.64541'
        stroke={color}
        fill={fill}
        strokeWidth={stroke}
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <Path
        fill-rule='evenodd'
        clip-rule='evenodd'
        d='M1 9.85156L1 2.07616C1 1.39996 1.5484 0.851562 2.2246 0.851562L11.8 0.851562C12.463
         0.851562 13 1.38856 13 2.05156L13 9.85156C13 10.5146 12.463 11.0516 11.8 11.0516L2.2
          11.0516C1.537 11.0516 1 10.5146 1 9.85156Z'
        stroke={color}
        fill={fill}
        strokeWidth={stroke}
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <Path
        d='M8.79688 4.44844H11.1969'
        stroke={color}
        fill={fill}
        strokeWidth={stroke}
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <Path
        d='M10.2369 6.85469H8.79688'
        stroke={color}
        fill={fill}
        strokeWidth={stroke}
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <Path
        d='M7.05619 8.65312C6.95119 8.38972 6.78919 8.15332 6.58099 7.96072V7.96072C6.22879 7.63432
         5.76679 7.45312 5.28679 7.45312H4.51159C4.03159 7.45312 3.56959 7.63432 3.21739
          7.96072V7.96072C3.00919 8.15332 2.84719 8.38972 2.74219 8.65312'
        stroke={color}
        fill={fill}
        strokeWidth={stroke}
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </IconBase>
  )
}

Username.propTypes = {
  color: PropTypes.string,
  stroke: PropTypes.string,
  fill: PropTypes.string,
}

export default Username
